import { Icon, Button } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, Pressable, Spinner } from 'native-base';
import React from 'react';

interface DownloadButtonProps {
  isDownloading?: boolean;
  onPress?: () => void;
  isDisabled: boolean;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  isDownloading = false,
  ...rest
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const downloadIconColor = rest.isDisabled ? 'neutral.light' : 'brand.tertiary.principal';
  const icon = isDownloading ? (
    <Spinner size="sm" color={Color['brand.tertiary.principal']} />
  ) : (
    <Icon name="Download" size="xs" color={Color[downloadIconColor]} />
  );

  if (isMobile) {
    return (
      <Box h={Spacing['inline.xxs']} w="full" alignItems="flex-end">
        <Button
          p={0}
          rightIcon={icon}
          _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}
          variant="textLink"
          {...rest}>
          Download
        </Button>
      </Box>
    );
  }

  return (
    <Pressable w="30px" {...rest}>
      {icon}
    </Pressable>
  );
};
